import { RepeatDetailsItem } from '@sb/library/data-models';


export enum RecurrenceType {
    Once = 'Once',
    HoldWeekly = 'HoldWeekly',
    Recurring = 'Recurring'
}

export class RecurrencePickerItem {
    constructor(config?: {
        RepeatDetails?: RepeatDetailsItem | null,
        IsLastInSeries?: boolean,
        IsHold?: boolean,
        HoldExpiry?: number | null,
        ApplyToFutureEntries?: boolean,
    }) {
        if (config?.RepeatDetails && config.IsHold) { throw Error('Cannot have both repeatDetails and isHold'); }
        if (!config?.RepeatDetails && config?.IsLastInSeries) { throw Error('Cannot have isLastInSeries without repeatDetails'); }

        this.RepeatDetails = config?.RepeatDetails ? config.RepeatDetails : null;
        this.IsLastInSeries = config?.IsLastInSeries ?? false;
        this.IsHold = config?.IsHold ?? false;
        this.HoldExpiry = config?.HoldExpiry ?? null;
    }

    RepeatDetails: RepeatDetailsItem | null = null;
    IsLastInSeries: boolean = false;
    IsHold: boolean = false;
    HoldExpiry: number | null = null;
    ApplyToFutureEntries: boolean = true;
}
